import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Link as LinkIcon,
  CameraAlt as CameraAltIcon,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { setAutoScrollPageNumber } from "app/store/transmission/slice/transmissionSlice";

const InitialView = ({ handlePDFPageNavigation }) => {
  const dispatch = useDispatch();

  const { currentPageNumber, autoScrollPageNumber, isReportNoteEditable } =
    useSelector((state) => state.transmission);

  const handleAutoScrollCameraClick = () => {
    autoScrollPageNumber
      ? dispatch(setAutoScrollPageNumber(null))
      : dispatch(setAutoScrollPageNumber(currentPageNumber));
  };

  return isReportNoteEditable ? (
    <div
      className="d-flex flex-end align-items-end flex-column"
      data-action="initial-view-icon"
      style={{ padding: "2px" }}
    >
      <p>Initial View</p>

      <div className="d-flex">
        <Tooltip
          title={
            autoScrollPageNumber
              ? `Unlink page for initial view: ${autoScrollPageNumber}`
              : `Link page for initial view: ${currentPageNumber || "None"}`
          }
        >
          <CameraAltIcon
            onClick={handleAutoScrollCameraClick}
            style={{
              color: autoScrollPageNumber ? "#94ba33" : "#949494",
              marginLeft: "10px",
              cursor: "pointer",
              fontSize: "24px",
            }}
          />
        </Tooltip>
        {autoScrollPageNumber && (
          <div className="d-flex align-items-center">
            <Tooltip title={`Go To page ${autoScrollPageNumber}`}>
              <LinkIcon
                onClick={() => handlePDFPageNavigation(autoScrollPageNumber)}
                className="report-note-editable-hyperlink"
              />
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div
      className="d-flex flex-end align-items-center"
      style={{ padding: "2px" }}
    >
      {autoScrollPageNumber ? (
        <Tooltip title={`Navigate to page ${autoScrollPageNumber}`}>
          <div
            onClick={() => handlePDFPageNavigation(autoScrollPageNumber)}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            Initial View page {autoScrollPageNumber}
          </div>
        </Tooltip>
      ) : (
        <p>Initial View not set</p>
      )}
    </div>
  );
};

export default InitialView;
